export default "__VITE_ASSET__D_zt2zVL__"